import { ChangeEvent } from 'react';
import LimitIndicator from './LimitIndicator';

type InputChangeEvent = ChangeEvent<HTMLTextAreaElement>;

type Props = {
  autoFocus?: boolean;
  disabled?: boolean;
  maxLength?: number;
  name?: string;
  onChange: (val: string) => void;
  placeholder?: string;
  value: string;
}

export default function TextareaField({
  maxLength,
  onChange,
  value,
  ...rest
}: Props) {

  const handleChange = (event: InputChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <>
      <textarea
        className="block w-full h-32 py-2 px-3 border border-blue rounded text-sm resize-none outline-none placeholder:italic"
        maxLength={maxLength}
        onChange={handleChange}
        value={value}
        {...rest}
      />

      { maxLength && <LimitIndicator value={value.length} max={maxLength} />}
    </>
  );
};
